import React, { Component } from 'react'
import { connect } from 'react-redux'
import formatDate from 'dateformat'
import TimeAgo from 'timeago.js'

import classNames from './ExternalShares.css'
import LoadingSpinner from '../components/LoadingSpinner'
import ErrorMessage from '../components/ErrorMessage'
import { logout } from '../redux/auth'
import { fetch } from '../utils/fetch'
import { isSuperAdmin } from '../utils/auth'
import {
  ENDPOINT_USER_SESSIONS,
  ENDPOINT_ALL_USER_SESSIONS,
  ENDPOINT_LOGOUT_ALL
} from '../constants'

const formatTimeAgo = new TimeAgo().format

class UserSessions extends Component {
  state = {
    data: null,
    fetching: false,
    error: null,
    loggingOut: false,
    filterUser: null
  }
  componentDidMount () {
    this.fetchSessions()
  }
  fetchSessions = () => {
    this.setState({ error: null })
    this.props.fetchSessions().then(
      data => this.setState({ data: data.records }),
      error => this.setState({ error })
    )
  }
  onClickLogOutAll = () => {
    this.setState({ loggingOut: true })
    this.props.logOutAllSessions().then(() => {
      this.props.logout()
    })
  }
  onChangeUserFilter = e => {
    this.setState({
      filterUser: parseInt(e.target.value)
    })
  }
  filterData = session => {
    if (this.state.filterUser && session.user_id !== this.state.filterUser) {
      return false
    }
    if (this.state.filterActive && session.expired) {
      return false
    }
    return true
  }
  getUsers = data => {
    const object = {}
    for (let session of data) {
      object[session.user_id] = session.user_name
    }
    return object
  }
  renderSession = (session) => {
    return (
      <tr key={session.id}>
        <td>{session.user_name}</td>
        <td>{session.expired ? '' : 'yes'}</td>
        <td title={formatDate(session.date, 'HH:MM, d mmm yyyy')}>
          {formatTimeAgo(session.date)}
        </td>
        <td>{session.ip}</td>
        <td>{session.os}</td>
        <td>{session.browser}</td>
      </tr>
    )
  }
  render () {
    const { data, fetching, error } = this.state

    if (error) {
      return (
        <ErrorMessage
          message='There was an error fetching user sessions'
          onRetry={this.fetchSessions}
        />
      )
    }

    if (!data || fetching) {
      return <LoadingSpinner />
    }

    const users = this.getUsers(data)

    return (
      <div className={classNames.page} style={{ maxWidth: '640px' }}>
        {this.props.showAllUsers &&
          <label>
            Filter users
            <br />
            <select onChange={this.onChangeUserFilter}>
              <option value={null}>All users</option>
              {Object.keys(users).map(id => (
                <option value={id}>{users[id]}</option>
              ))}
            </select>
          </label>
        }
        <label>
          <input
            type='checkbox'
            checked={this.state.filterActive}
            onChange={() => this.setState({ filterActive: !this.state.filterActive })}
          />
          Active sessions only
        </label>
        <table className={classNames.table} style={{ width: '100%' }}>
          <tbody>
            <tr>
              <th>User</th>
              <th>Active</th>
              <th>Created</th>
              <th>IP</th>
              <th>OS</th>
              <th>Browser</th>
            </tr>
            {data.filter(this.filterData).map(this.renderSession)}
          </tbody>
        </table>
        <button
          className={classNames.button}
          style={{ display: 'block', margin: '20px auto' }}
          onClick={this.onClickLogOutAll}
          disabled={this.state.loggingOut}>
          {this.state.loggingOut ? 'Logging out…' : 'Log out all of my sessions'}
        </button>
      </div>
    )
  }
}

const mapStateToProps = ({ auth, share, users, entities }) => {
  const showAllUsers = isSuperAdmin(auth.user)
  const endpoint = showAllUsers
    ? ENDPOINT_ALL_USER_SESSIONS
    : ENDPOINT_USER_SESSIONS.replace(':id', auth.user.id)
  return {
    showAllUsers,
    fetchSessions: () => fetch(endpoint, { token: auth.token }),
    logOutAllSessions: () => fetch(ENDPOINT_LOGOUT_ALL, {
      method: 'post',
      token: auth.token
    })
  }
}

const mapDispatchToProps = {
  logout
}

export default connect(mapStateToProps, mapDispatchToProps)(UserSessions)



// WEBPACK FOOTER //
// ./src/pages/UserSessions.js